jQuery(document).ready(function($) {

  $("#gallery__content__inner").justifiedGallery({
    rowHeight: 200,
    lastRow: 'center',
    maxRowsCount: 0,
    captions: false,
    getCaptionFromTitleOrAlt: true,
    pullCaptionUp: true,
  });

  /******************************************************************************\
    Gallery images
  \******************************************************************************/
  // $('.gallery').lightGallery({

  //   thumbnail: true,
  //   selector: '.item',

  // });

  // Product Gallery
  // $(".fancybox").fancybox();
  /******************************************************************************\
    Readmore
  \******************************************************************************/
  $('.more').readmore({
    speed: 300,
    collapsedHeight: 150,
    moreLink: '<a href="#" data-readmore-toggle class="level-one-button btn-small level-one-btn_bg_inverted level-one-btn_col_inverted btn-read-more">Visa mer</a>',
    lessLink: '<a href="#" data-readmore-toggle class="level-one-button btn-small level-one-btn_bg_inverted level-one-btn_col_inverted btn-read-more">Visa mindre</a>',
    heightMargin: 16
  });

  /******************************************************************************\
    Cookie notification
  \******************************************************************************/
  // $(".site").cookieNotify({
  //   cookieText: 'Vi använder <a href="'+ibab_wp.cookies_page_url+'" title="Om cookies">cookies</a> för att ge dig en bättre upplevelse av vår webb. Genom att använda vår hemsida godkänner du detta.',
  //   cookieButtonText: 'Jag förstår'
  // });
  /******************************************************************************\
    stacktable.js
  \******************************************************************************/
  $('table:not(#no-stacktable):not(.shop_table):not(.shop_table_responsive):not(.variations):not(.cookielawinfo-row-cat-table').stacktable({myClass:'stacktabale-res'});

  /******************************************************************************\
    Remove width & height attributes from images (added by default in WordPress)
  \******************************************************************************/
  $('img').removeAttr('width').removeAttr('height');

  /******************************************************************************\
    Remove style attribute on image captions, which sets a fixed width by default
  \******************************************************************************/
  $('.wp-caption').removeAttr('style');

  /******************************************************************************\
    Slide in divs on scroll
  \******************************************************************************/
  // See demo: http://michalsnik.github.io/aos/
  // See config: https://github.com/michalsnik/aos
  //
  AOS.init();

  /******************************************************************************\
    Parralax
  \******************************************************************************/
  // See demo: https://dixonandmoe.com/rellax/
  // See config: https://github.com/dixonandmoe/rellax

  /******************************************************************************\
    Cookies Url
  \******************************************************************************/
  // get the url to page titled cookies


  /******************************************************************************\
    Search
  \******************************************************************************/
  $('.icon-search-icon').click(function() {
    $('.search-overlay').addClass('search-overlay--visible');
  });
  $('.search-close').click(function() {
    $('.search-overlay').removeClass('search-overlay--visible');
  });


  /******************************************************************************\
      Tiny slider
  \******************************************************************************/

  if ($('.front-one-slider').length > 0) {
    var slider = tns({
      container: '.front-one-slider',
      items: 1,
      slideBy: 'page',
      speed: 700,
      nav: true,
      navPosition: 'bottom',
      controls: false,
      autoHeight: true,
      autoplayTimeout: 15000,
    });
  }


  /******************************************************************************\
      News Param - Scroll to item
  \******************************************************************************/
  var getUrlParameter = function getUrlParameter(sParam) {
    var sPageURL = window.location.search.substring(1),
      sURLVariables = sPageURL.split('&'),
      sParameterName,
      i;

    for (i = 0; i < sURLVariables.length; i++) {
      sParameterName = sURLVariables[i].split('=');

      if (sParameterName[0] === sParam) {
        return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
      }
    }
  };

  var newsSlug = getUrlParameter('item') || null;
  if (newsSlug) {
    // Scroll to a certain element
    var yOffset = -100;
    var element = document.getElementById(newsSlug);
    var y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;

    window.scrollTo({
      top: y,
      behavior: 'smooth'
    });

  }

  /******************************************************************************\
      Mobile menu
  \******************************************************************************/
  $(".select-css").change(function(value) {
    console.log($(this));
    // window.location = window.location.origin + window.location.pathname + '?catid=' + $(this).val();
  });

  var menuItems = $('.mobile-menu__wrapper .menu.main-menu li');
  var menuItemsCount = menuItems.length;

  if (menuItemsCount < 4) {
    $(menuItems).addClass('menuItemLargest');
  } else if (menuItemsCount >= 4) {
    $(menuItems).addClass('menuItemMedium');
  } else if (menuItemsCount > 6) {
    $('.mobile-menu__content__info').hide();
    $(menuItems).addClass('menuItemSmallest');
  }

  /******************************************************************************\
      Mobile menu
  \******************************************************************************/
  // Hide mobile menu on wide screens
  $(window).resize(function() {

    $('.mobile-menu__wrapper--open').removeClass('mobile-menu__wrapper--open');
    $('.mobile-menu__wrapper__overlay--open').removeClass('mobile-menu__wrapper__overlay--open');
    $('.hamburger').removeClass('is-active');

  });

  // Open mobile menu
  $('.header-hamburger, .mobile-menu__close').on('click', function(e) {
    $('body').toggleClass('mobile-menu--open');
    $('.hamburger').toggleClass('is-active');
    $('.mobile-menu__wrapper').toggleClass('mobile-menu__wrapper--open');
    $('.mobile-menu__wrapper__overlay').toggleClass('mobile-menu__wrapper__overlay--open');
    e.stopImmediatePropagation();
  });

  // Toggle subpages in mobile menu
  $('.main-menu--mobile .menu-item-has-children > a').append('<span class="menu-item__toggle"></span>');
  $('.menu-item__toggle').on('click', function(e) {
    e.preventDefault();
    if (!$(this).hasClass('toggling')) {
      $target = $(this);
      $(this).parent().next('.sub-menu').slideToggle(function() {
        $target.removeClass('toggling');
      });
      $(this).addClass('toggling');
      $(this).toggleClass('menu-item__toggle--open');
      $(this).closest('li').toggleClass('menu-item--open');
    }
  });

  $('.main-nav--mobile li.current_page_parent, main-nav--mobile li.current_page_ancestor').addClass('menu-item--open');

  // TeasersOverlays
  var levelThumbs = '.level-teasers--teaser__inner';
  var levelAnimationEl = '.overlay-info, img';
  var levelOverlay = '.overlay-info';
  var ovlSpeed = 400;
  var animeItems = '.anime';

  var levelFunctions = {

    init: function() {
      levelFunctions.mason();
      levelFunctions.hovers();
      levelFunctions.anime();
    },
    mason: function() {
      $('.level-teasers').isotope({
        itemSelector: '.level-teasers__teaser',
        masonry: {
          columnWidth: '.grid-sizer'
        }
      });
    },
    anime: function() {
      $(animeItems).each(function(i, el) {

        var animationProperties = $(el).data('anime').split(';');
        var preset = animationProperties[0].split(':')[1];
        var delay = animationProperties[1].split(':')[1];

        if (preset === 'fadeIn') {
          anime({
            targets: el,
            opacity: [0,1],
            delay: delay,
            easing: 'easeInOutExpo'
          });

        } else if (preset === 'slideInUpShort') {

          anime({
            targets: el,
            opacity: 1,
            translateY: [50,0],
            delay: delay,
            easing: 'easeInOutExpo'
          });

        } else if (preset === 'slideInRightShort') {

          anime({
            targets: el,
            opacity: 1,
            translateX: [50,0],
            delay: delay,
            easing: 'cubicBezier(.5, .05, .1, .3)'
          });

        } else if (preset === 'slideInLeftShort') {

          anime({
            targets: el,
            opacity: 1,
            translateX: [-50,0],
            delay: delay,
            easing: 'cubicBezier(.5, .05, .1, .3)'
          });

        } else if (preset === 'slideInDownShort') {

          anime({
            targets: el,
            opacity: 1,
            translateY: [-50,0],
            delay: delay,
            easing: 'cubicBezier(.5, .05, .1, .3)'
          });

        } else if (preset === 'scaleIn') {

          anime({
            targets: el,
            opacity: 1,
            scale: [.6,1],
            delay: delay,
            easing: 'cubicBezier(.5, .05, .1, .3)'
          });

        } else if (preset === 'flipInX') {

          anime({
            targets: el,
            opacity: 1,
            rotateX: [-180,0],
            delay: delay,
            easing: 'cubicBezier(.5, .05, .1, .3)'
          });

        }



      });
    },
    hovers: function() {
      $(levelThumbs).each(function() {
        $(this).find(levelAnimationEl).css({
          transitionDuration: '1000ms',
          transitionTimingFunction: 'easeInOut'
        });
        $(this).find(levelOverlay).css({
          backgroundColor: 'rgba(0,0,0,.5)'
        });
      });
    },
  };
  levelFunctions.init();


  var setHeader = function(scoll) {

    if ($(window).scrollTop() >= $('.intro-wrapper,.news-wrapper,.common-wrapper,.single-product,.archive-wrapper,.content-area').offset().top - 300) {
      $('.nav-bg').removeClass('bg-hidden');
      $('.nav-bg').addClass('bg-visible');
      if (ibab_wp.menu_always_white !== "white_bg" && scoll !== false) {
        $('body .header').addClass('level-one-compact');
        $('body .header').removeClass('level-one-transparent');
      }
      $('body:has(.page) .header').addClass('level-one-compact');
      $('body:has(.page) .header').removeClass('level-one-transparent');
      $('.level-one-compact .nav-bar-inner nav  ul  li.menu-item  a').addClass('color-theme-primary_color');
    } else {
      $('.nav-bg').removeClass('bg-visible');
      $('.nav-bg').addClass('bg-hidden');
      $('.header').removeClass('level-one-compact');
      $('.header').addClass('level-one-transparent');
      $('.level-one-compact .nav-bar-inner nav > ul > li > a').removeClass('color-theme-primary_color');
    }
  };
  // Set OnLoad
  if ($('.intro-wrapper,.news-wrapper,.common-wrapper,.content-area').length > 0 ) {
    setHeader(false);
  }


  // Set OnScroll
  $(window).on('scroll', function() {
    if ($(window).scrollTop() < 1000) {
      $('.hero_text h1, .site-branding').css('opacity', 1 - ($(window).scrollTop() / 300));
    }
    if ($('.intro-wrapper,.news-wrapper,.common-wrapper,.single-product, .archive-wrapper, .content-area, .gmflex-wrapper, .content-wrapper').length > 0 ) {
      setHeader(true);
    }
  });

  //
  // if(ibab_wp.menu_always_white == "white_bg") {
  //   $('.nav-bg').removeClass('bg-hidden');
  //   $('.nav-bg').addClass('bg-visible');
  //   $('.header').addClass('level-one-compact');
  //   $('.header').removeClass('level-one-transparent');
  //   $('.level-one-compact .nav-bar-inner nav  ul  li.menu-item  a').addClass('color-theme-primary_color');
  // } else {
  //   $('.nav-bg').addClass('bg-hidden');
  //   $('.nav-bg').removeClass('bg-visible');
  //   $('.header').removeClass('level-one-compact');
  //   $('.header').addClass('level-one-transparent');
  //   $('.level-one-compact .nav-bar-inner nav  ul  li.menu-item  a').addClass('color-theme-primary_color');
  // }
const swiper = new Swiper('.hero-bildspel', {
	direction: 'horizontal',
	loop: true,
	slidesPerView:1,
	spaceBetween: 20,
  // effect: 'fade',
  autoplay: {
    delay: 3000,
    disableOnInteraction: false,
  },
  effect:'creative',
  speed: 3000,
  creativeEffect: {
    prev: {
      // kenburns effect
      scale: 0.95,
      //add a slight fade
      opacity: 0.95,
    },
    next: {
      // kenburns effect
      scale: 1.1,
      //add a slight fade
      opacity: 0.95,
    },
  },

});

});






